<template>
	<div class="auth-social">
		<!--
		<BaseCmsLabel v-if="mode == 'register'" class="login-social-title register-social-title" tag="div" code="register_social_title" />
		<BaseCmsLabel v-else class="login-social-title" tag="div" code="login_social_title" />
		-->
		<BaseAuthSocialLogin v-slot="{socialLogin, loadingFacebook, loadingGoogle}">
			<div class="btns">
				<button class="btn-medium btn-social btn-facebook" :class="{'loading': loadingFacebook}" @click="socialLogin('Facebook')">Facebook</button>
				<button class="btn-medium btn-social btn-google" :class="{'loading': loadingGoogle}" @click="socialLogin('Google')">Google</button>
			</div>
		</BaseAuthSocialLogin>

		<BaseCmsLabel code="social_note" tag="div"  class="auth-social-note" />
	</div>
</template>

<style lang="less" scoped>
	.btns{display: flex; gap: 10px; padding: 0 0 10px;}
	.btn-social{
		width: 50%; background: #1878F2;
		&:before{.icon-facebook(); font: 15px/1 var(--fonti);}
		&:after{display: none;}
	}
	.btn-facebook{
		.transition(background);
		@media (min-width: @h){
			&:hover{background: #0d65d9;}
		}
	}
	.btn-google{
		background: #fff; color: var(--textColor); border: 1px solid var(--borderColor); gap: 6px; .transition(border-color);
		&:before{content: ''; background: url(assets/images/icons/google.svg) no-repeat center; background-size: contain; width: 19px; height: 19px; position: relative; top: 1px;}
		@media (min-width: @h){
			&:hover{border-color: var(--blue);}
		}
	}
	.auth-social-note{
		display: block; font-size: 12px; line-height: 1.2; font-weight: 700; color: var(--darkGray); margin: 6px 0 16px;
		@media (max-width: @m){margin: 4px 0 12px;}	
	}
</style>
